import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const AboutCountryCanada = () => {
  const navigate = useNavigate();

  const CanadaData = {
    title: "Study Abroad Opportunities Canada",
    mTitle: "Why Study in Canada?",
    desc_1:
      "Canada is one of the top destinations for international students, known for its high-quality education, safe environment, and multicultural society. Canadian universities are recognized globally for academic excellence and research-driven programs that prepare students for successful global careers.",
    desc_2:
      "Studying in Canada not only means access to world-class education, but also the opportunity to experience a high standard of living, vibrant cities, and stunning natural landscapes. With post-graduation work permits and permanent residency pathways, Canada is a smart choice for your future.",
  };

  const CanadaBenefits = [
    { title: "Globally Ranked Universities", number: 300, suffix: "+" },
    { title: "Affordable Tuition Fees", number: 100, suffix: "%" },
    { title: "Work While You Study", number: 20, suffix: "hrs/week" },
    { title: "Post-Graduation Opportunities", number: 3, suffix: "yrs PGWP" },
  ];

  const CanadaUniversities = [
  { title: "Algoma University", img: "/image/study-abroad/canada/algoma-university.png", link: "#" },
  { title: "College Avalon", img: "/image/study-abroad/canada/college-avalon.png", link: "#" },
  { title: "International Business University", img: "/image/study-abroad/canada/international-business-university.png", link: "#" },
  { title: "Laurentian University", img: "/image/study-abroad/canada/laurentian-university.png", link: "#" },
  { title: "PLC", img: "/image/study-abroad/canada/plc.png", link: "#" },
  { title: "Red Deer Polytechnic", img: "/image/study-abroad/canada/red-deer-polytechnic.png", link: "#" },
  { title: "Western Community College", img: "/image/study-abroad/canada/western-community-college.png", link: "#" },
  { title: "York College of Applied Science", img: "/image/study-abroad/canada/york-college-of-applied-science.png", link: "#" },
  { title: "Yorkville University", img: "/image/study-abroad/canada/yorkville-university.png", link: "#" },
];


  const responsiveCarousel = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
        <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>

      {/* Hero Section */}
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-indigo-700 mb-6">
          {CanadaData.title}
        </h1>

        {/* Carousel After Main Title */}
        <div className="mb-10 mt-10">
          <h3 className="text-2xl font-semibold text-indigo-600 mb-5 mt-5">
            Top Universities in Canada
          </h3>
          <p className="text-gray-600 mb-6 mt-5">Explore Our Partner Institutions</p>

          <Carousel
            responsive={responsiveCarousel}
            infinite
            autoPlay
            autoPlaySpeed={4000}
            arrows
            keyBoardControl
            showDots={false}
            containerClass="carousel-container-custom"
            itemClass="px-3"
            renderButtonGroupOutside={false}
          >
            {CanadaUniversities.map((univ, idx) => {
              const content = (
                <div className="bg-white mt-10 rounded-lg shadow hover:shadow-lg transition-all duration-300 p-4 text-center h-full flex flex-col items-center justify-between">
                  <img
                    src={univ.img}
                    alt={univ.title}
                    className="rounded-md max-h-36 w-full object-contain mb-3"
                    loading="lazy"
                  />
                  <h5 className="text-sm font-medium text-gray-700">
                    {univ.title}
                  </h5>
                </div>
              );
              return univ.link ? (
                <Link key={idx} to={univ.link}>
                  {content}
                </Link>
              ) : (
                <div key={idx}>{content}</div>
              );
            })}
          </Carousel>
        </div>

        {/* Description Section */}
        <h2 className="text-2xl text-indigo-600 font-semibold mb-4">
          {CanadaData.mTitle}
        </h2>
        <p className="text-gray-700 mb-3 leading-relaxed">{CanadaData.desc_1}</p>
        <p className="text-gray-700 leading-relaxed">{CanadaData.desc_2}</p>
          <img
          src="/image/about/about-07/canada.png"
          alt="Study in Canada"
          className="w-[30%] h-[30%] mx-auto mt-6 rounded-lg object-cover shadow"
        />
      </section>

      {/* Benefits Section */}
      <section className="mb-16">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Key Benefits of Studying in Canada
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {CanadaBenefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white p-6 rounded-xl shadow-md text-center border border-gray-100"
            >
              <div className="text-3xl font-bold text-indigo-600">
                {item.number}
                {item.suffix}
              </div>
              <p className="mt-2 text-lg font-medium text-gray-700">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition"
        >
          Apply Now!
        </button>
      </div>
    </div>
  );
};

export default AboutCountryCanada;
